import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function About() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const backgroundImage = isMobile
    ? "https://geneartai.com/images/mobile1.png"
    : "https://geneartai.com/images/image1.png";

  return (
    <div className="relative min-h-screen font-sans text-white overflow-x-hidden flex flex-col">

      {/* Background */}
      <div
        className="fixed inset-0 z-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('${backgroundImage}')`,
          backgroundAttachment: isMobile ? "scroll" : "fixed",
        }}
      >
        <div className="absolute inset-0 bg-black/30 backdrop-blur-sm" />
      </div>

      {/* Foreground Content */}
      <div className="relative z-10 flex-grow flex flex-col items-center px-6 sm:px-12 pt-28 pb-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl text-center bg-black/20 backdrop-blur-md p-8 rounded-xl shadow-xl"
        >
          <h1 className="text-3xl sm:text-4xl font-extrabold mb-4 text-yellow-400">About GeneArtAI</h1>
          <p className="text-gray-200 text-base sm:text-lg leading-relaxed mb-4">
            GeneArtAI was founded with a simple yet powerful vision — to empower
            creativity through the magic of artificial intelligence. Whether you're
            a designer, content creator, or simply someone who loves to explore,
            GeneArtAI helps you transform words into breathtaking artwork.
          </p>
          <p className="text-gray-200 text-base sm:text-lg leading-relaxed mb-4">
            With an easy-to-use interface and powerful models behind the scenes,
            anyone can generate beautiful, high-resolution images instantly.
            Our goal is to democratize AI creativity — no payments, no complexity,
            just pure imagination.
          </p>
          <p className="text-gray-200 text-base sm:text-lg leading-relaxed">
            We're committed to keeping GeneArtAI accessible, ethical, and community-driven.
            Join thousands of creators exploring a world of digital art, all powered by AI.
          </p>
        </motion.div>
      </div>

      {/* Footer */}
      <footer className="relative z-10 text-center text-xs text-gray-300 pb-6">
        <div>© 2025 GeneArtAI — All Rights Reserved.</div>
        <div className="mt-2">
          <Link to="/privacy-policy" className="text-gray-300 hover:text-white underline">
            Privacy Policy
          </Link>{" "}
          |{" "}
          <Link to="/terms-of-service" className="underline hover:text-white">
            Terms of Service
          </Link>
        </div>
      </footer>

      {/* Spacer for mobile */}
      <div className="block sm:hidden h-16" />
    </div>
  );
}
